/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Prompt/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Prompt({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/EditArea/QuestionFields/Content/Prompt",
  isInvalid,
  onChange
  
}) {
let questionPromptValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'prompt',
})
let questionPromptIsValidData = fromData.useDataIsValid({ viewPath,
context: 'question',
path: 'prompt',
validate: fromValidate.textInput,
required: true,
})
let questionPromptChangeData = fromData.useDataChange({ viewPath,
context: 'question',
path: 'prompt',
})
  return (<React.Fragment
>
<div
  data-testid="Prompt.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 maxWidth={562}
 data="question.prompt"
 validate="/Data/validate.js textInput"
 required={true}
 value={questionPromptValueData}
 invalid={!questionPromptIsValidData}
 onChange={questionPromptChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Prompt"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}